import React from 'react';

import {
  CarsListHeaderLeft,
  CarsListHeaderRight,
  CarsListHeaderWrapper,
} from '@/modules/CarsStock/components/common.styles';

import CarsFilterResult from './components/CarsFilterResult';
import Sorting from './components/Sorting';
import { CarsListHeaderProps } from './types';

function CarsListHeader({ carsType }: CarsListHeaderProps) {
  return (
    <CarsListHeaderWrapper id="carsListHeader">
      <CarsListHeaderLeft>
        <CarsFilterResult />
      </CarsListHeaderLeft>

      <CarsListHeaderRight>
        <Sorting carsType={carsType} />
      </CarsListHeaderRight>
    </CarsListHeaderWrapper>
  );
}

export default CarsListHeader;
